import { mainApi } from "../api/root-api"
import { loadingSchedules, setSchedules } from "../slices/scheduleSlice"
import { setError, setSuccess } from "../slices/statusSlice"

export const getSchedulesAction = (id, token ) => {
  const url = `/accounts/${id}/schedules`
  const headers = { headers: {authorization: token} }

  let payload
  return async ( dispatch ) => {
    dispatch(loadingSchedules())
    await mainApi.get(url, headers).then(resp => {
      payload = {
        message: 'Horarios',
        status: resp.status
      }  
      dispatch(setSchedules(resp.data))
      // dispatch(setSuccess(payload))
    }).catch(err => {
      payload = {
        message: err.response.data.message.error,
        status: err.response.status
      }  
      dispatch( setError(payload) )
    })
  }
}